import React from 'react'
import styled from 'styled-components'
import { colors } from 'styling/GlobalStyles';
import { OtherText } from 'styling/Typography';

export const Badge = ({ text, red, green, blue, orange, paleBlue }: { text: string; red?: boolean; green?: boolean; blue?: boolean; orange?: boolean; paleBlue?: boolean }) => {


  const borderColor = red ? colors.red : green ? colors.green : blue ? colors.blue : orange ? colors.orange : paleBlue ? colors.paleBlue : colors.orange;
  const backgroundColor = red ? colors.paleRed : green ? colors.paleGreen : blue ? colors.paleBlue : orange ? colors.paleOrange : paleBlue ? colors.paleBlue : colors.paleOrange;

  return <BadgeContainer borderColor={borderColor} backgroundColor={backgroundColor}><OtherText color={borderColor} style={{ textTransform: 'uppercase' }} weight='500'>{text}</OtherText></BadgeContainer>
}

const BadgeContainer = styled.div<{
  borderColor?: string
  backgroundColor?: string
}>`
  background-color: ${({ backgroundColor }) => (backgroundColor)};
  border: 1px solid ${({ borderColor, theme }) => borderColor || theme.tableRowBorder};
  padding: 2px 8px;
  border-radius: 8px;
  color: ${({ borderColor, theme }) => borderColor || theme.textFaded};
  height: fit-content;
  display: flex;
  align-items: center;
  height: 20px;
  width: fit-content;
  padding: 0px 8px;

`

